import { Injectable } from '@angular/core';
import { $DBManagerService } from '../_helpers/DB/DBManager.service';
import { config } from '../_config/config';
import { Constants } from '../_utils/Constants';
import { isUndefined, isEmpty } from '../_utils/Common';


@Injectable()
export class $AuthManagerService {

    constructor(
        private $db: $DBManagerService
    ) { }

    public isAuthExists(key: string): boolean {
        const v = this.$db.get(Constants.SESSSION_STORAGE, key);
        if (!isUndefined(v) && !isEmpty(v)) {
            //  if (config.encryption)
            //      if (this.$db.isDecryptValid(v))
            //          return true;
            //      else
            //          return false;
            return true;
        }
        return false;
    }

    public setAuthData(key: string, value: any): void {
        this.$db.set(Constants.SESSSION_STORAGE, key, value);
    }

}
